export class SoakTypeRequest{
    type: string
    constructor(type:string){
        this.type = type
    }
}